import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import styles from './ErrorPage.module.css';

export function ErrorPage() {
  const error = useRouteError();

  const message = isRouteErrorResponse(error)
    ? `${error.status} — ${error.statusText}`
    : error instanceof Error
    ? error.message
    : 'An unexpected error occurred.';

  return (
    <main className={styles.page} id="main-content">
      <div className={styles.inner}>
        <h1 className={styles.heading}>Something went wrong</h1>
        <p className={styles.message}>{message}</p>
        <p>
          <Link to="/" className={styles.homeLink}>
            Return to Home
          </Link>
        </p>
      </div>
    </main>
  );
}
